import {useMutation} from "@tanstack/react-query";
import {assignPermissionToRoleMutationOptions} from "./assign-permission-to-role.mutation-options";

export function useAssignPermissionToRole(roleId: string) {
  return useMutation(assignPermissionToRoleMutationOptions(roleId));
}
